import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';

export default function swiperStickyCta() {
    const elements = document.querySelectorAll('.js-sticky-cta-swiper');

    if (!elements.length) return;

    elements.forEach((el) => {
        new Swiper(el, {
            modules: [Pagination],
            slidesPerView: 'auto',
            centeredSlides: true,
            spaceBetween: 16,
            pagination: {
                el: el.querySelector('.swiper-pagination'),
                clickable: true,
            },
        });
    });
}
